import { render } from "./GameOverModal.vue?vue&type=template&id=5b9be424&scoped=true"
import script from "./GameOverModal.vue?vue&type=script&lang=js"
export * from "./GameOverModal.vue?vue&type=script&lang=js"

import "./GameOverModal.vue?vue&type=style&index=0&id=5b9be424&scoped=true&lang=css"

import exportComponent from "/home/josh/git/crackle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9be424"]])

export default __exports__